// console.info("routerTs");
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Login from "@/views/login.vue";
import Join from "@/views/join.vue";
import successJoin from "@/views/successJoin.vue";
import joinAgree from "@/views/joinAgree.vue";
import JoinSample from "@/views/joinSample.vue";
import findId from "@/views/findId.vue";
import findPassword from "@/views/findPassword.vue";
import changePassword from "@/views/changePassword.vue";

import Main from "@/views/main.vue";

import HealthDetailHeartRate from "@/views/healthDetail/heartRate.vue";
import healthDetailElectro from "@/views/healthDetail/electrocardiogram.vue";
import healthDetailOxygen from "@/views/healthDetail/oxygen.vue";
import healthDetailStress from "@/views/healthDetail/stress.vue";
import healthDetailVegetable from "@/views/healthDetail/vegetable.vue";
import healthDetailtemperature from "@/views/healthDetail/temperature.vue";

import serveyList from "@/views/survey/list.vue";
import serveyDetail from "@/views/survey/detail.vue";

import communityList from "@/views/community/list.vue";
import communityWrite from "@/views/community/write.vue";
import communityDetail from "@/views/community/detail.vue";

import stressCareList from "@/views/stressCare/list.vue";
import stressCareCategory from "@/views/stressCare/category.vue";
import stressCareDetail from "@/views/stressCare/detail.vue";

import youtubeList from "@/views/youtube/list.vue";
import youtubeDetail from "@/views/youtube/detail.vue";

import myPage from "@/views/mypage/mypage.vue";
import userModify from "@/views/mypage/userModify.vue";
import passwordModify from "@/views/mypage/modifyPassword.vue";


import VasList from "@/views/vas/list.vue";
import VasStressPoint from "@/views/vas/stressPoint.vue";
import VasDailyStress from "@/views/vas/dailyStress.vue";

import { userStore } from "@/BaseComponent";
const routes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/join",
        name: "Join",
        component: JoinSample,
    },
    {
        path: "/joinAgree",
        name: "JoinAgree",
        component: joinAgree,
    },
    {
        path: "/joinTest",
        name: "JoinTest",
        component: Join,
    },
    {
        path: "/successJoin",
        name: "SuccessJoin",
        component: successJoin,
    },
    {
        path: "/findId",
        name: "findId",
        component: findId,
    },
    {
        path: "/findPassword",
        name: "findPassword",
        component: findPassword,
    },
    {
        path: "/changePassword",
        name: "changePassword",
        component: changePassword,
    },
    {
        path: "/",
        name: "Main",
        component: Main,
        meta: { requiresAuth: true },
    },
    {
        path: "/health/detail/heartRate",
        name: "HealthDetailHeartRate",
        component: HealthDetailHeartRate,
        meta: { requiresAuth: true },
    },
    {
        path: "/health/detail/electrocardiogram",
        name: "healthDetailElectro",
        component: healthDetailElectro,
        meta: { requiresAuth: true },
    },
    {
        path: "/health/detail/vegetableIngredients",
        name: "healthDetailVegetable",
        component: healthDetailVegetable,
        meta: { requiresAuth: true },
    },
    {
        path: "/health/detail/oxygenSaturation",
        name: "healthDetailOxygen",
        component: healthDetailOxygen,
        meta: { requiresAuth: true },
    },
    {
        path: "/health/detail/stress",
        name: "healthDetailStress",
        component: healthDetailStress,
        meta: { requiresAuth: true },
    },
    {
        path: "/health/detail/temperature",
        name: "healthDetailtemperature",
        component: healthDetailtemperature,
        meta: { requiresAuth: true },
    },

    {
        path: "/stressCare/category",
        name: "stressCareCategory",
        component: stressCareCategory,
        meta: { requiresAuth: true },
    },
    {
        path: "/stressCare/list",
        name: "stressCareList",
        component: stressCareList,
        meta: { requiresAuth: true },
    },
    {
        path: "/stressCare/detail/:idx",
        name: "stressCareDetail",
        component: stressCareDetail,
        meta: { requiresAuth: true },
    },
    {
        path: "/youtube/list",
        name: "youtubeList",
        component: youtubeList,
        meta: { requiresAuth: true },
    },
    {
        path: "/youtube/detail/:idx",
        name: "youtubeDetail",
        component: youtubeDetail,
        meta: { requiresAuth: true },
    },
    {
        path: "/survey/list",
        name: "serveyList",
        component: serveyList,
        meta: { requiresAuth: true },
    },
    {
        path: "/survey/detail/:idx",
        name: "serveyDetail",
        component: serveyDetail,
        meta: { requiresAuth: true },
    },
    {
        path: "/community/list",
        name: "communityList",
        component: communityList,
        meta: { requiresAuth: true },
    },
    {
        path: "/community/write",
        name: "communityWrite",
        component: communityWrite,
        meta: { requiresAuth: true },
    },
    {
        path: "/community/detail/:idx",
        name: "communityDetail",
        component: communityDetail,
        meta: { requiresAuth: true },
    },

    {
        path: "/myPage",
        name: "myPage",
        component: myPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/userModify",
        name: "userModify",
        component: userModify,
        meta: { requiresAuth: true },
    },
    {
        path: "/passwordModify",
        name: "passwordModify",
        component: passwordModify,
        meta: { requiresAuth: true },
    },

    {
        path: "/VAS/list",
        name: "VASList",
        component: VasList,
    },
    {
        path: "/VAS/stressPoint",
        name: "VasStressPoint",
        component: VasStressPoint,
    },
    {
        path: "/VAS/dailyStress",
        name: "VasDailyStress",
        component: VasDailyStress,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// 라우터 네비게이션 가드 설정
router.beforeEach((to, from, next) => {
    const user = userStore();
    // console.info(from);
    // console.info(to);
    const isLoggedIn = user !== null && user.token !== "" && user.token !== null;
    // console.info(isLoggedIn);
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // 해당 라우트에 인증이 필요한 경우
        if (!isLoggedIn) {
            // 로그인이 되어 있지 않은 경우
            next({ name: "Login" }); // 로그인 페이지로 이동
        } else {
            next(); // 다음 단계로 이동
        }
    } else {
        next(); // 인증이 필요하지 않은 경우 다음 단계로 이동
    }
});

export default router;
